<div
  class="tooltip"
  role="tooltip"
  aria-label="Bulle d'information"
  (mouseenter)="showTooltip()"
  (mouseleave)="hideTooltip()"
  (focus)="showTooltip()"
  (focusout)="hideTooltip()"
  (pressEscapeKey)="hideTooltip()"
  appPressEscapeKey
>
  <ng-content
    select="[element]"
    [id]="id"
    class="btn-clean tooltip__text"
    (click)="click()"
    aria-describedby="tooltip-content"
  ></ng-content>
  <div
    [@fadeInOnEnter]
    [@fadeOutOnLeave]
    class="tooltip__container"
    [class.tooltip__container--into-modal]="isLargeContentIntoModal"
    [class.tooltip__container--hidden]="(showTooltip$ | async) === false"
    (mouseenter)="showTooltip()"
    (mouseleave)="hideTooltip()"
    id="tooltip-content"
  >
    <ng-content select="[modal-content]"></ng-content>
  </div>
</div>
